import type { APIUser } from 'Models/models';
import type { RoleName } from 'Backend/user-management/utils/roleName';

import { creatorPermissionsV2 } from 'Backend/user-management/utils/creatorPermissionsV2';
import { managerPermissionsV2 } from 'Backend/user-management/utils/managerPermissionsV2';
import { ownerPermissionsV2 } from 'Backend/user-management/utils/ownerPermissionsV2';
import { viewerPermissionsV2 } from 'Backend/user-management/utils/viewerPermissionsV2';

type RoleType = {
    Name: RoleName;
    Id: RoleName;
    Permissions: APIUser['permissions'];
};

export const roleTypes: RoleType[] = [
    {
        Name: 'Owner',
        Id: 'Owner',
        Permissions: ownerPermissionsV2,
    },
    {
        Name: 'Manager',
        Id: 'Manager',
        Permissions: managerPermissionsV2,
    },
    {
        Name: 'Creator',
        Id: 'Creator',
        Permissions: creatorPermissionsV2,
    },
    {
        Name: 'Viewer',
        Id: 'Viewer',
        Permissions: viewerPermissionsV2,
    },
];
